import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './hero.css'

const Hero = (props) => {
  return (
    <div id={props.heroId} className="hero-container">
      <div className="hero-column thq-section-padding">
        <div className="hero-content">
          <span className="hero-job-titles">
            {props.jobsText ?? (
              <Fragment>
                <span className="hero-text15">
                  <span>Software Engineer | </span>
                  <span>Data Engineer | </span>
                  <span>System Architect | </span>
                  <span>Sociologist</span>
                </span>
              </Fragment>
            )}
          </span>
          <span className="hero-hi-text">
            {props.helloText ?? (
              <Fragment>
                <span className="hero-text10">
                  <span className="hero-text11">Hi,</span>
                  <br className="hero-text12"></br>
                  <span className="hero-text13">I&apos;m Stefan Lacher.</span>
                  <br></br>
                </span>
              </Fragment>
            )}
          </span>
        </div>
      </div>
      <img
        id="Hero_image"
        alt={props.imageSelfAlt}
        src={props.imageSelfSrc}
        className="hero-image1"
      />
    </div>
  )
}

Hero.defaultProps = {
  heroId: 'HeroId',
  helloText: undefined,
  imageSelfAlt: 'Image of a person working on a laptop',
  jobsText: undefined,
  imageSelfSrc: '/2024-05-25_ls_014-500h.webp',
}

Hero.propTypes = {
  heroId: PropTypes.string,
  helloText: PropTypes.element,
  imageSelfAlt: PropTypes.string,
  jobsText: PropTypes.element,
  imageSelfSrc: PropTypes.string,
}

export default Hero
